import Promotional from './Promotional';

export {Promotional};


// WEBPACK FOOTER //
// ./src/Components/Home/index.js